/**
 * Recent gym sales — real, closed transactions.
 * Source: Bonza Business & Franchise Sales spreadsheet (Gym Sales.xlsx).
 * Rows are copied verbatim from the source workbook (Sheet1) with columns
 * normalised to { sold_price, days_on_market, interested_buyers, state }.
 * DO NOT edit these values without a matching spreadsheet update.
 *
 * State counts (from the workbook):
 *   NSW = 14, QLD = 23, VIC = 8, WA = 6  (total 51)
 */

export const STATES_META = [
  {
    code: "NSW",
    label: "New South Wales",
    image:
      "https://images.unsplash.com/photo-1571902943202-507ec2618e8f?auto=format&fit=crop&w=1600&q=70",
  },
  {
    code: "QLD",
    label: "Queensland",
    image:
      "https://images.unsplash.com/photo-1534438327276-14e5300c3a48?auto=format&fit=crop&w=1600&q=70",
  },
  {
    code: "VIC",
    label: "Victoria",
    image:
      "https://images.unsplash.com/photo-1517836357463-d25dfeac3438?auto=format&fit=crop&w=1600&q=70",
  },
  {
    code: "WA",
    label: "Western Australia",
    image:
      "https://images.unsplash.com/photo-1540497077202-7c8a3999166f?auto=format&fit=crop&w=1600&q=70",
  },
];

// Rows: { sold_price (AUD), days_on_market, interested_buyers, state }
export const RECENT_SALES = [
  // ---------- NSW (14) ----------
  { state: "NSW", sold_price: 315000, days_on_market: 345, interested_buyers: 95 },
  { state: "NSW", sold_price: 220000, days_on_market: 385, interested_buyers: 21 },
  { state: "NSW", sold_price: 100000, days_on_market: 113, interested_buyers: 22 },
  { state: "NSW", sold_price: 99990, days_on_market: 28, interested_buyers: 15 },
  { state: "NSW", sold_price: 75000, days_on_market: 111, interested_buyers: 35 },
  { state: "NSW", sold_price: 75000, days_on_market: 200, interested_buyers: 9 },
  { state: "NSW", sold_price: 52000, days_on_market: 230, interested_buyers: 66 },
  { state: "NSW", sold_price: 410000, days_on_market: 305, interested_buyers: 50 },
  { state: "NSW", sold_price: 250000, days_on_market: 248, interested_buyers: 34 },
  { state: "NSW", sold_price: 175000, days_on_market: 132, interested_buyers: 30 },
  { state: "NSW", sold_price: 149000, days_on_market: 64, interested_buyers: 36 },
  { state: "NSW", sold_price: 65000, days_on_market: 245, interested_buyers: 37 },
  { state: "NSW", sold_price: 52000, days_on_market: 195, interested_buyers: 9 },
  { state: "NSW", sold_price: 75000, days_on_market: 290, interested_buyers: 38 },

  // ---------- QLD (23) ----------
  { state: "QLD", sold_price: 135000, days_on_market: 109, interested_buyers: 42 },
  { state: "QLD", sold_price: 198000, days_on_market: 180, interested_buyers: 81 },
  { state: "QLD", sold_price: 140000, days_on_market: 83, interested_buyers: 7 },
  { state: "QLD", sold_price: 99000, days_on_market: 204, interested_buyers: 47 },
  { state: "QLD", sold_price: 90000, days_on_market: 140, interested_buyers: 64 },
  { state: "QLD", sold_price: 80000, days_on_market: 125, interested_buyers: 40 },
  { state: "QLD", sold_price: 75000, days_on_market: 296, interested_buyers: 38 },
  { state: "QLD", sold_price: 50979, days_on_market: 423, interested_buyers: 111 },
  { state: "QLD", sold_price: 396166, days_on_market: 131, interested_buyers: 7 },
  { state: "QLD", sold_price: 375000, days_on_market: 201, interested_buyers: 16 },
  { state: "QLD", sold_price: 375000, days_on_market: 208, interested_buyers: 19 },
  { state: "QLD", sold_price: 230000, days_on_market: 164, interested_buyers: 11 },
  { state: "QLD", sold_price: 182000, days_on_market: 315, interested_buyers: 32 },
  { state: "QLD", sold_price: 150000, days_on_market: 357, interested_buyers: 128 },
  { state: "QLD", sold_price: 120000, days_on_market: 190, interested_buyers: 73 },
  { state: "QLD", sold_price: 117000, days_on_market: 265, interested_buyers: 60 },
  { state: "QLD", sold_price: 40000, days_on_market: 369, interested_buyers: 38 },
  { state: "QLD", sold_price: 35000, days_on_market: 283, interested_buyers: 22 },
  { state: "QLD", sold_price: 179000, days_on_market: 75, interested_buyers: 19 },
  { state: "QLD", sold_price: 80000, days_on_market: 35, interested_buyers: 176 },
  { state: "QLD", sold_price: 65000, days_on_market: 337, interested_buyers: 154 },
  { state: "QLD", sold_price: 60000, days_on_market: 53, interested_buyers: 8 },
  { state: "QLD", sold_price: 50000, days_on_market: 90, interested_buyers: 14 },

  // ---------- VIC (8) ----------
  { state: "VIC", sold_price: 250000, days_on_market: 474, interested_buyers: 33 },
  { state: "VIC", sold_price: 249000, days_on_market: 210, interested_buyers: 92 },
  { state: "VIC", sold_price: 55000, days_on_market: 273, interested_buyers: 24 },
  { state: "VIC", sold_price: 49000, days_on_market: 372, interested_buyers: 42 },
  { state: "VIC", sold_price: 99999, days_on_market: 415, interested_buyers: 13 },
  { state: "VIC", sold_price: 60000, days_on_market: 223, interested_buyers: 40 },
  { state: "VIC", sold_price: 149999, days_on_market: 215, interested_buyers: 13 },
  { state: "VIC", sold_price: 129000, days_on_market: 113, interested_buyers: 40 },

  // ---------- WA (6) ----------
  { state: "WA", sold_price: 20000, days_on_market: 103, interested_buyers: 16 },
  { state: "WA", sold_price: 115000, days_on_market: 433, interested_buyers: 80 },
  { state: "WA", sold_price: 60000, days_on_market: 242, interested_buyers: 73 },
  { state: "WA", sold_price: 120000, days_on_market: 93, interested_buyers: 16 },
  { state: "WA", sold_price: 145000, days_on_market: 133, interested_buyers: 80 },
  { state: "WA", sold_price: 157500, days_on_market: 142, interested_buyers: 73 },
];

export function salesForState(code) {
  return RECENT_SALES.filter((r) => r.state === code);
}

export function summariseSales(rows) {
  if (rows.length === 0) return null;
  const n = rows.length;
  const total = rows.reduce((s, r) => s + r.sold_price, 0);
  const avgPrice = total / n;
  const medianPrice = [...rows].sort((a, b) => a.sold_price - b.sold_price)[Math.floor(n / 2)].sold_price;
  const avgDom = rows.reduce((s, r) => s + r.days_on_market, 0) / n;
  const avgBuyers = rows.reduce((s, r) => s + r.interested_buyers, 0) / n;
  const highest = Math.max(...rows.map((r) => r.sold_price));
  const lowest = Math.min(...rows.map((r) => r.sold_price));
  return {
    count: n,
    total,
    avg_price: Math.round(avgPrice),
    median_price: medianPrice,
    avg_dom: Math.round(avgDom),
    avg_buyers: Math.round(avgBuyers),
    highest,
    lowest,
  };
}
